var CurrentUser = require("lib/account/CurrentUser");
var StudentMetrics = require("lib/data/StudentMetrics");

import { connect } from "react-redux";
import { CircularProgressbar } from 'react-circular-progressbar';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

class StudentProgressDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {  }
	}
	render() {
		var progress;
		if (this.props.progress) {
			progress = this.props.progress; 
		} else {
			progress = this.props.current / this.props.total; 
		}
		progress = Math.min((progress || 0.0), 1.0);

		var percent = Math.round(progress * 100);
		var total = this.props.total;

		var metric = this.props.metric;
		
		if (metric == "pages") {
			var imageMetric = "minutes";	
		} else if (metric == "days-active") {
			var imageMetric = "questions";
		} else {
			var imageMetric = metric;
		}
		
		if (!this.props.hideButton) {
			var button = (
				<button className="buttonPrimary" onClick={ this.props.openBookSearch }>{ StudentMetrics.getActionButtonText(metric) }</button>
			)
		}

		return (
			<div className="circleContainer">
				<CircularProgressbarWithChildren value={percent} className="largeCircle"
		            circleRatio={0.75}
		            styles={{
						trail: {
						strokeLinecap: 'butt',
						transform: 'rotate(-135deg)',
						transformOrigin: 'center center',
						},
						path: {
						strokeLinecap: 'butt',
						transform: 'rotate(-135deg)',
						transformOrigin: 'center center',
						}, }}>
				  	{/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
				  	<img src={ StudentMetrics.getIcon(imageMetric) } className="metricIcon" />
				  	<div className="infoContainer">
				  		<p className="statTotal">{ this.props.current }</p>
				    	<p className="metricCategory">{ StudentMetrics.getLabel(metric) }</p>
				    	<p className="totalText">Goal: { this.props.total }</p>
				    	{ button }
				  	</div>
				</CircularProgressbarWithChildren>
			</div>
		);
	}

	// componentDidMount() {
	// }
}

StudentProgressDisplay.propTypes = StrictPropTypes({
	metric: PropTypes.string,
	title: PropTypes.string,
	unit: PropTypes.string,
	current: PropTypes.number,
	total: PropTypes.number,
	actionLabel: PropTypes.string,
	openBookSearch: PropTypes.func,
	hideButton: PropTypes.bool
});

module.exports = StudentProgressDisplay;


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentProgressDisplay.js